import { render, staticRenderFns } from "./Dhcp.vue?vue&type=template&id=97cdd90c&"
import script from "./Dhcp.vue?vue&type=script&lang=js&"
export * from "./Dhcp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports